import MESSAGES from "../../utils/Constants"
import validator from 'validator';


export const fnFormValidation = (pState, pErrorState, pSetErrorState, pPropertyArray) => {
    let fErrorStatus = []
    for (let i = 0; i < pPropertyArray.length; i++) {
        let key = pPropertyArray[i]
        if (pState[key] === '' || pState[key] === undefined || pState[key] === null) {
            let sKey = key.replace(/_/gi, ' ')
            const sWords = sKey.split(" ");
            let sFinalWords = sWords.map((word) => { 
                return word[0].toUpperCase() + word.substring(1); 
            }).join(" ")
            
            fErrorStatus.push(sFinalWords +" - "+ MESSAGES.FIELD_REQUIRED) 
            pSetErrorState(pErrorState => ({ ...pErrorState, [key]: MESSAGES.FIELD_REQUIRED }))
        }
    }
    return fErrorStatus
}

export const fnMobileNumberValidation = (pState, pErrorState, pSetErrorState, pPropertyArray, pErrorStatus) => {
    for (let i = 0; i < pPropertyArray.length; i++) {
        let key = pPropertyArray[i];
        let mobileNumber = pState[key];

        if (mobileNumber !== '' && mobileNumber !== undefined) {
            let requiredLength = key === 'alternate_mobile_number' ? 11 : 10;

            // Length validation
            if (mobileNumber.length < 10 || mobileNumber.length > requiredLength) {
                let sKey = key.replace(/_/gi, ' ');
                const sWords = sKey.split(" ");
                let sFinalWords = sWords.map((word) => word[0].toUpperCase() + word.substring(1)).join(" ");

                pErrorStatus.push(`${sFinalWords} - Mobile number must be ${key === 'alternate_mobile_number' ? '10 or 11' : 'exactly 10'} digits.`);
                pSetErrorState(pErrorState => ({
                    ...pErrorState,
                    [key]: `Mobile number must be ${key === 'alternate_mobile_number' ? '10 or 11' : 'exactly 10'} digits.`
                }));
            }
            // Validate the mobile number format
            else if (!validator.isMobilePhone(mobileNumber, 'en-IN') && key !== 'alternate_mobile_number') {
                let sKey = key.replace(/_/gi, ' ');
                const sWords = sKey.split(" ");
                let sFinalWords = sWords.map((word) => word[0].toUpperCase() + word.substring(1)).join(" ");

                pErrorStatus.push(`${sFinalWords} - ${MESSAGES.ENTER_VALID_MOBILE_NUMBER}`);
                pSetErrorState(pErrorState => ({
                    ...pErrorState,
                    [key]: MESSAGES.ENTER_VALID_MOBILE_NUMBER
                }));
            }
        }
    }
    return pErrorStatus;
};

export const fnEmailValidation = (pState, pErrorState, pSetErrorState, pPropertyArray, pErrorStatus) => {
    for (let i = 0; i < pPropertyArray.length; i++) {
        let key = pPropertyArray[i]
        if (pState[key] !== '' && pState[key] !== undefined) {
            if (!validator.isEmail(pState[key])) {
                let sKey = key.replace(/_/gi, ' ')
                const sWords = sKey.split(" ");
                let sFinalWords = sWords.map((word) => { 
                    return word[0].toUpperCase() + word.substring(1); 
                }).join(" ")
                
                pErrorStatus.push(sFinalWords +" - "+ MESSAGES.ENTER_VALID_EMAIL_ADDRESS) 
                pSetErrorState(pErrorState => ({ ...pErrorState, [key]: MESSAGES.ENTER_VALID_EMAIL_ADDRESS }))
            }
        }
    }
    return pErrorStatus
}
